import http from "../jslibs/axios/http";

// 直播列表
export const getLiveList = (data) => http.get("/v1/cms/live", data);
// 分类
export const getLiveType = (data) => http.get("/v1/cms/ArticleCate", data);
// 新增直播
export const addLive = (data) => http.post(`/v1/cms/live`, data);
// 直播详情
export const getLiveDetail = (uuid) => http.get(`/v1/cms/live/${uuid}`);
// 直播编辑
export const editLive = (data, uuid) => http.put(`/v1/cms/Live/${uuid}`, data);
// 删除直播
export const deleteLive = (uuid) => http.delete(`/v1/cms/Live/${uuid}`);
// 置顶取消
export const setTopLive = (uuid) => http.get(`/v1/cms/LiveTop/${uuid}`);
// 上下架
export const LiveStatus = (uuid) => http.get(`/v1/cms/LiveStatus/${uuid}`);

// 房间列表
export const getRoomList = (data) => http.get(`/v1/app/live`, data);

// // 课程列表
export const LiveCourse = (data) => http.get(`/v1/cms/LiveCourse`, data);
// // 开始直播
export const startLive = (uuid, data) => http.get(`/v1/cms/LiveStart/${uuid}`, data);
// // 房间列表
export const roomList = (data) => http.get(`/v1/cms/HouseAction`, data);
// // 数据
export const roomData = (uuid, data) => http.get(`/v1/cms/LiveDate/${uuid}`, data);
// // 用户列表
export const userList = (uuid, data) => http.get(`/v1/cms/UserLook`, uuid);
// // 弹幕列表
export const getDanmu = (data) => http.get(`/v1/cms/BarrageAction`, data);
// 发布弹幕
export const sendDanmu = (data) => http.post(`/v1/cms/BarrageAction`, data);

// // 付费记录
export const payList = (data) => http.get(`/v1/cms/LiveOrder`, data);
// // 操作
export const editPay = (data, order_id) => http.put(`/v1/cms/LiveOrder/${order_id}`, data);
// 导出
export const LiveOrderExport = (data) => http.down(`/v1/cms/LiveOrderExport`, data);
// 订单详情
export const getOrderDetail = (uuid) => http.get(`/v1/cms/LiveOrder/${uuid}`);
